import React__default, { useContext } from 'react';
import { Application } from '../ApplicationContext/index.js';

var ChatContext = React__default.createContext({
  customMessageComponents: [],
  applicationContext: Application.CONSUMER
});
var ChatContextProvider = ChatContext.Provider;
var ChatContextConsumer = ChatContext.Consumer;

var useChatContext = function useChatContext() {
  return useContext(ChatContext);
};

export { ChatContext, ChatContextConsumer, ChatContextProvider, useChatContext };
//# sourceMappingURL=index.js.map
